export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '韩漫网站的漫画是免费的吗？',
    answer: '是的，我们提供大量韩国漫画免费在线观看。部分热门连载漫画可能会有一定的付费章节，但绝大多数内容都是免费的，让您随时随地享受阅读乐趣。',
  },
  {
    id: 'faq-2',
    question: '漫画的更新频率是怎样的？',
    answer: '我们与多家韩国漫画平台合作，热门连载漫画通常每周更新1-2话。您可以关注喜欢的漫画，获得更新提醒，不错过任何精彩内容。',
  },
  {
    id: 'faq-3',
    question: '支持哪些设备阅读？',
    answer: '我们的网站采用响应式设计，完美支持电脑、平板和手机等各种设备。无论您使用什么设备，都能获得流畅舒适的阅读体验。',
  },
  {
    id: 'faq-4',
    question: '如何找到我喜欢的漫画类型？',
    answer: '您可以通过顶部的分类导航浏览不同类型的漫画，也可以使用搜索功能直接查找作品名称或作者。我们的智能推荐系统还会根据您的阅读喜好，为您推荐可能感兴趣的漫画。',
  },
  {
    id: 'faq-5',
    question: '可以下载漫画离线阅读吗？',
    answer: '目前我们主要提供在线阅读服务，确保您能随时获取最新更新的内容。在线浏览也保证了最佳的画质体验和流畅的加载速度。',
  },
];